import { Check, X, Info, CircleAlert } from 'lucide-react';
import { motion, AnimatePresence } from 'motion/react';
import DOMPurify from 'dompurify';
import { useA11y } from '../hooks/useA11y.js';

export function Notification({ id, type, message, allowUndo, undo, onUndo }) {
  // SOK-09: con "Pantalla baja" las notificaciones van abajo a la izquierda y entran por ese lado.
  const { settings } = useA11y();
  const offscreenX = settings.low ? '-100%' : '100%';

  const getBackgroundColor = () => {
    switch (type) {
      case 'success':
        return '#00bc7d';
      case 'error':
        return '#ff6467';
      case 'info':
        return '#00d3f2';
      case 'neutral': // Algo no válido que no es un error (p. ej. un código escaneado que no existe).
      default:
        return '#90a1b9';
    }
  };

  const getTextColor = () => {
    switch (type) {
      case 'success':
        return '#b9f8cf';
      case 'error':
        return '#ffc9c9';
      case 'info':
        return '#cefafe';
      case 'neutral':
      default:
        return '#e2e8f0';
    }
  };

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <Check />;
      case 'error':
        return <X />;
      case 'info':
        return <Info />;
      default:
        return <CircleAlert />;
    }
  };

  const handleUndo = (e) => {
    e.stopPropagation();
    if (onUndo) onUndo(id);
  };

  return (
    <motion.div
      layout
      id={id}
      className="min-w-[500px] max-w-[50%] px-10 py-5 secondary-font-regular flex items-center justify-start gap-5 rounded-lg shadow-lg m-4 text-xl"
      style={{ backgroundColor: getBackgroundColor(), color: getTextColor(), pointerEvents: 'auto' }}
      onClick={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
      initial={{ x: offscreenX, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: offscreenX, opacity: 0 }}
    >
      <div className="w-[30px]">
        {getIcon()}
      </div>
      <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message) }} />
      {allowUndo && undo && onUndo && (
        <motion.button
          onClick={handleUndo}
          className="cursor-pointer ml-4 border-2 p-3 rounded-lg"
          style={{borderColor: getTextColor(), color: getTextColor()}}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.5 }}
        >Deshacer
        </motion.button>
      )}
    </motion.div>
  );
}